import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  classReportDetails,
  cohortDetailsMap,
  cohortIdMap,
  readingCohorts,
  resultMetricExplaination,
} from "../../../utils/CommonUtils/constants";
import useParamValues from "../../../utils/useParamValues";
import useTranslationSetup from "../../../utils/useTranslationSetup";
import "./styles.css";

const CohortisedStudentList = ({ cohorts, pageIndex, classLength }) => {
  const { t } = useTranslationSetup();
  const useParamValue = useParamValues();
  const isFirstPage = pageIndex === 0;
  const classReportInfo = classReportDetails(t, classLength, useParamValue);
  const classInfo = [classReportInfo[0], classReportInfo[2]];

  const maxRows = Math.max(...Object.values(cohorts).map((c) => c.length));

  return (
    <>
      <Box className="cohortised-student-list-container">
        <Box className="class-details-container">
          {classInfo.map((item, index) => (
            <Box className="class-details-grid-item" key={index}>
              <Typography className="class-details-grid-item-label">
                {item.label}
              </Typography>
              <Typography className="class-details-grid-item-value">
                {item.value}
              </Typography>
            </Box>
          ))}
        </Box>
        {isFirstPage && (
          <Typography className="class-details-class-section">
            {`${t("class")} ${useParamValue?.classNum} - ${t("section")} ${useParamValue?.section}`}
          </Typography>
        )}
        <Box
          className={`class-details-cohort-header-container ${!isFirstPage && "add-padding"}`}
        >
          {readingCohorts(t).map((item, index) => (
            <Box
              className={`class-details-cohort-header-item bg-color-${index}`}
              key={index}
            >
              <Typography className="class-details-cohort-header-item-label">
                {item.label}
              </Typography>
              <img
                src={item.icon}
                className="class-details-cohort-header-item-icon"
                alt="cohort-icon"
              />
            </Box>
          ))}
        </Box>
        {isFirstPage && (
          <Box className="class-details-result-metrics-icon-label-container">
            {Object.entries(resultMetricExplaination(t)).map(([key, value]) => (
              <Box
                className="class-details-result-metrics-icon-label-item"
                key={key}
              >
                <img
                  className="class-details-result-metrics-icon"
                  src={value.icon}
                  alt="result-metric-icon"
                />
                <Typography className="class-details-result-metrics-label">
                  {value.label}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
        <Box>
          <Table className="class-details-result-metric-table">
            {isFirstPage && (
              <TableHead>
                <TableRow>
                  {readingCohorts(t).map((_, rc_index) => (
                    <TableCell
                      className={`class-details-result-metric-table-header-cell bg-color-${rc_index}`}
                      key={rc_index}
                    >
                      <Box className="class-details-result-metric-table-header-container">
                        {Object.entries(
                          cohortDetailsMap[cohortIdMap[rc_index + 1]]
                            .rangesByGrade[useParamValue?.classNum]
                        ).map(([key, value]) => (
                          <Box
                            className="class-details-result-metric-table-header-item"
                            key={key}
                          >
                            <img
                              className="class-details-result-metric-table-header-icon"
                              src={resultMetricExplaination(t)[key].icon}
                              alt="reading-cohort-icon"
                            />
                            <Typography className="class-details-result-metric-table-header-metric">
                              {value}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            )}
            <TableBody>
              {Array.from({ length: maxRows }).map((_, i) => (
                <TableRow
                  className={`${i % 2 !== 0 && "class-details-result-metric-table-body-row"}`}
                  key={i}
                >
                  {[1, 2, 3, 4].map((c) => (
                    <TableCell
                      className="class-details-result-metric-table-body-cell"
                      key={c}
                    >
                      {cohorts[c][i]?.name || ""}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </>
  );
};

export default CohortisedStudentList;
